export default "__VITE_ASSET__736dd759__"